export { PriceText } from './PriceText';
export { default } from './PriceText';
